// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__eNOkP","icon":"tag_icon__sxuDB","text":"tag_text__h2urO"};